import React from 'react';

import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

// PrimeReact components
import {Button} from 'primereact/button';
import {Checkbox} from 'primereact/checkbox';
import {Card} from 'primereact/card';
import {Dialog} from 'primereact/dialog';
import {InputText} from 'primereact/inputtext';
import {InputTextarea} from 'primereact/inputtextarea';
import {Dropdown} from 'primereact/dropdown';
import {Spinner} from 'primereact/spinner';
import {Chips} from 'primereact/chips';

// Catalog constants
import {CriterionList, TypeOfRecommendations} from '../catalog/catalog-constants';

// Criteria custom UI components
import TVRatingList from '../components-core/tv-rating-list';
import StarRatingList from '../components-core/star-rating-list';
import FeaturedFolderList from '../components-core/featured-folder-list';
import NetworkList from '../components-core/network-list';
import NetworkTags from '../components-core/network-tags';
import ProductTypeList from '../components-core/product-type-list';
import ThemeList from '../components-core/theme-list';
import ReleaseDecadePicker from '../components-core/release-decade-picker';
import ResolutionPicker from '../components-core/resolution-picker';
import ExtendedAttributesList from '../components-core/extended-attributes-list';
import MPAARatingList from '../components-core/mpaa-rating-list';
import AirDayOfWeekList from '../components-core/air-day-of-week-picker';
import AliasesList from '../components-core/aliases-list';
import Subtheme from '../components-core/subtheme';

import * as addShelfActions from '../actions/shelf-actions';
import {push} from '../actions/router-actions';

// Styles
import './criteria-form.scss';
import {isArray, map, startsWith, uniqBy} from 'lodash';

export const MatchTypes = {
    DEFAULT: {label: 'Default'},
    CONTAINS: {label: 'Contains'},
    STARTS_WITH: {label: 'Starts With'},
    ENDS_WITH: {label: 'Ends With'},
    EXACT_MATCH: {label: 'Exact Match'},
};

class CriteriaForm extends React.Component {
    state = {
        deleteDialogVisible: false,
    };

    handleDeleteCriteria = () => {
        const {deleteCriteria} = this.props;
        const {criteriaObjToDelete} = this.state;

        if (criteriaObjToDelete != null) {
            deleteCriteria(criteriaObjToDelete.class);
            this.setState({deleteDialogVisible: false});
        }
    };

    onDeleteDialogHide = () => {
        this.setState({deleteDialogVisible: false});
    };

    onClickDeleteCriteria = criteriaObjToDelete => {
        this.setState({deleteDialogVisible: true, criteriaObjToDelete});
    };

    renderShelfCriteria(criteriaObj, idx) {
        const {
            handleChange,
            handleUpdateAlias,
            handleUpdateExtAttributes,
            handleUpdateNetworkTags,
            handleUpdateSubTheme,
            updateResolutionList,
        } = this.props;

        let criterionForm = null;

        switch (criteriaObj.class) {
            case 'Actor':
                criterionForm = this.renderActor(criteriaObj, idx, handleChange);
                break;
            case 'Aliases':
                criterionForm = this.renderAliases(criteriaObj, idx, handleUpdateAlias);
                break;
            case 'Resolution':
                criterionForm = this.renderResolution(criteriaObj, idx, handleChange, updateResolutionList);
                break;
            case 'RecommendationType':
                criterionForm = this.renderRecommendationType(criteriaObj, idx, handleChange);
                break;
            case 'ReleaseDate':
                criterionForm = this.renderReleaseDecade(criteriaObj, idx, handleChange);
                break;
            case 'ReleaseYear':
                criterionForm = this.renderReleaseYear(criteriaObj, idx, handleChange);
                break;
            case 'CharacterPage':
                criterionForm = this.renderCharacterPage(criteriaObj, idx, handleChange);
                break;
            case 'Keyword':
                criterionForm = this.renderKeyword(criteriaObj, idx, handleChange);
                break;
            case 'TVRating':
                criterionForm = this.renderTVRating(criteriaObj, idx, handleChange);
                break;
            case 'MPAA':
                criterionForm = this.renderMPAARating(criteriaObj, idx, handleChange);
                break;
            case 'CriticsRating':
                criterionForm = this.renderCriticsRating(criteriaObj, idx, handleChange);
                break;
            case 'Folder':
                criterionForm = this.renderFeaturedFolder(criteriaObj, idx, handleChange);
                break;
            case 'Network':
                criterionForm = this.renderNetwork(criteriaObj, idx, handleChange);
                break;
            case 'LateNight':
                criterionForm = this.renderLateNight(criteriaObj, idx, handleChange);
                break;
            case 'SeriesID':
                criterionForm = this.renderSeriesID(criteriaObj, idx, handleChange);
                break;
            case 'EchostarId':
                criterionForm = this.renderEchostarIDs(criteriaObj, idx, handleChange);
                break;
            case 'ProductType':
                criterionForm = this.renderProductType(criteriaObj, idx, handleChange);
                break;
            case 'Theme':
                criterionForm = this.renderTheme(criteriaObj, idx, handleChange);
                break;
            case 'Directors':
                criterionForm = this.renderDirector(criteriaObj, idx, handleChange);
                break;
            case 'AirDayOfWeek':
                criterionForm = this.renderAirDayOfWeek(criteriaObj, idx, handleChange);
                break;
            case 'Amount':
                criterionForm = this.renderAmount(criteriaObj, idx, handleChange);
                break;
            case 'NetworkTags':
                criterionForm = this.renderNetworkTags(criteriaObj, idx, handleUpdateNetworkTags);
                break;
            case 'SubTheme':
                criterionForm = this.renderSubTheme(criteriaObj, idx, handleUpdateSubTheme);
                break;
            case 'ExtendedAttribute':
                criterionForm = this.renderExtendedAttributes(criteriaObj, idx, handleUpdateExtAttributes);
                break;
            case 'Title':
                criterionForm = this.renderTitle(criteriaObj, idx, handleChange);
                break;
            default:
                criterionForm = <p>Unknown criterion selected</p>;
        }

        return criterionForm;
    }

    renderExtendedAttributes = ({attributes} = {}, criteriaId, handleUpdateExtAttributes) => (
        <div>
            <ExtendedAttributesList
                handleUpdateExtAttributes={handleUpdateExtAttributes}
                id={`extendedAttributes${criteriaId}`}
                name={`extendedAttributes${criteriaId}`}
                values={attributes}
            />
        </div>
    );

    renderNetworkTags = ({tags} = {}, criteriaId, handleUpdateNetworkTags) => (
        <div>
            <NetworkTags
                handleUpdateNetworkTags={handleUpdateNetworkTags}
                id={`networkTags${criteriaId}`}
                name={`networkTags${criteriaId}`}
                values={tags}
            />
        </div>
    );

    renderSubTheme = ({genres} = {}, criteriaId, handleUpdateSubTheme) => (
        <div>
            <Subtheme
                handleUpdateSubTheme={handleUpdateSubTheme}
                id={`subTheme${criteriaId}`}
                name={`subTheme${criteriaId}`}
                values={genres}
            />
        </div>
    );

    renderAliases = ({aliases} = {}, criteriaId, handleUpdateAlias) => (
        <div>
            <AliasesList
                handleUpdateAlias={handleUpdateAlias}
                id={`aliases${criteriaId}`}
                name={`aliases${criteriaId}`}
                values={aliases}
            />
        </div>
    );

    renderActor({keyword, matchType} = {}, criteriaId, handleChange) {
        const matchTypeOptions = Object.keys(MatchTypes).map(matchType => ({
            label: MatchTypes[matchType].label,
            value: matchType,
        }));

        return (
            <div className="criteria-form--actor-criteria">
                <label htmlFor={`actorName${criteriaId}`}>Actor Name</label>
                <InputText
                    className="criteria-form--actor-text"
                    id={`actorName${criteriaId}`}
                    value={keyword}
                    onChange={handleChange}
                />

                <br />
                <br />
                <label htmlFor={`matchType${criteriaId}`}>Match Type</label>
                <Dropdown
                    className="criteria-form--match-type"
                    filterPlaceholder="Select Match Type"
                    id={`matchType${criteriaId}`}
                    options={matchTypeOptions}
                    showClear={false}
                    value={matchType}
                    onChange={handleChange}
                />
            </div>
        );
    }

    renderDirector = ({directors} = {}, criteriaId, handleChange) => (
        <div className="criteria-form--director-criteria p-fluid">
            <label htmlFor={`directorName${criteriaId}`}>
                Hit the carriage return key to enter another director name.
            </label>

            <Chips
                className="criteria-form--director-chips"
                id={`directorName${criteriaId}`}
                value={directors}
                onChange={handleChange}
            />
        </div>
    );

    renderTVRating = ({rating} = {}, criteriaId, handleChange) => (
        <div>
            <TVRatingList
                id={`tvRating${criteriaId}`}
                name={`tvRating${criteriaId}`}
                value={rating}
                onChange={handleChange}
            />
        </div>
    );

    renderKeyword({keyword, matchType, fields} = {}, criteriaId, handleChange) {
        const matchTypeOptions = Object.keys(MatchTypes).map(matchType => ({
            label: MatchTypes[matchType].label,
            value: matchType,
        }));

        const fieldOptions = [
            {label: '0', value: 0},
            {label: '1', value: 1},
            {label: '2', value: 2},
            {label: '3', value: 3},
            {label: '64', value: 64},
            {label: '8192', value: 8192},
        ];

        return (
            <div className="criteria-form--keyword-criteria">
                <label htmlFor={`keyword${criteriaId}`}>Keyword</label>
                <InputText
                    className="criteria-form--keyword-text"
                    id={`keyword${criteriaId}`}
                    value={keyword}
                    onChange={handleChange}
                />

                <br />
                <br />
                <label htmlFor={`matchType${criteriaId}`}>Match Type</label>
                <Dropdown
                    className="criteria-form--match-type"
                    filterPlaceholder="Select Match Type"
                    id={`matchType${criteriaId}`}
                    options={matchTypeOptions}
                    showClear={false}
                    value={matchType}
                    onChange={handleChange}
                />

                <br />
                <br />
                <label htmlFor={`fields${criteriaId}`}>Fields</label>
                <Dropdown
                    className="criteria-form--fields"
                    filterPlaceholder="Select Value of Fields"
                    id={`fields${criteriaId}`}
                    options={fieldOptions}
                    showClear={false}
                    value={fields}
                    onChange={handleChange}
                />
            </div>
        );
    }

    renderCharacterPage = ({startCharacter, endCharacter} = {}, criteriaId, handleChange) => (
        <div className="criteria-form--charpage-criteria">
            <label htmlFor={`charPageStart${criteriaId}`}>Start Character</label>
            <InputText
                className="criteria-form--charpage-text"
                id={`charPageStart${criteriaId}`}
                value={startCharacter}
                onChange={handleChange}
            />

            <br />
            <br />
            <label htmlFor={`charPageEnd${criteriaId}`}>End Character</label>
            <InputText
                className="criteria-form--charpage-text"
                id={`charPageEnd${criteriaId}`}
                value={endCharacter}
                onChange={handleChange}
            />
        </div>
    );

    renderMPAARating = ({ratings} = {}, criteriaId, handleChange) => (
        <div>
            <MPAARatingList
                criteriaId={criteriaId}
                existingRatings={ratings}
                id={`mpaaRating${criteriaId}`}
                name={`mpaaRating${criteriaId}`}
                onChange={handleChange}
            />
        </div>
    );

    renderCriticsRating = ({lowCriticsRating} = {}, criteriaId, handleChange) => (
        <div>
            <StarRatingList
                id={`criticsRating${criteriaId}`}
                name={`criticsRating${criteriaId}`}
                value={lowCriticsRating}
                onChange={handleChange}
            />
        </div>
    );

    renderFeaturedFolder = ({featuredFolderID} = {}, criteriaId, handleChange) => (
        <div>
            <FeaturedFolderList
                id={`featuredFolder${criteriaId}`}
                name={`featuredFolder${criteriaId}`}
                value={featuredFolderID}
                onChange={handleChange}
            />
        </div>
    );

    renderNetwork = ({name} = {}, criteriaId, handleChange) => (
        <div>
            <NetworkList
                id={`network${criteriaId}`}
                name={`network${criteriaId}`}
                value={name}
                onChange={handleChange}
            />
        </div>
    );

    renderProductType = ({type} = {}, criteriaId, handleChange) => (
        <div>
            <ProductTypeList
                id={`product${criteriaId}`}
                name={`product${criteriaId}`}
                value={type}
                onChange={handleChange}
            />
        </div>
    );

    renderTheme = ({category} = {}, criteriaId, handleChange) => (
        <div>
            <ThemeList id={`theme${criteriaId}`} name={`theme${criteriaId}`} value={category} onChange={handleChange} />
        </div>
    );

    renderResolution = ({resolution} = {}, criteriaId, handleChange, updateResolutionList) => (
        <ResolutionPicker
            criteriaId={criteriaId}
            id={`res${criteriaId}`}
            name={`res${criteriaId}`}
            resolution={resolution}
            updateResolutionList={updateResolutionList}
            onChange={handleChange}
        />
    );

    renderLateNight = ({includeLateNight} = {}, criteriaId, handleChange) => (
        <div>
            <Checkbox
                checked={includeLateNight}
                id={`lateNight${criteriaId}`}
                inputId={`lateNight${criteriaId}`}
                onChange={handleChange}
            />
        </div>
    );

    renderSeriesID = ({seriesID} = {}, criteriaId, handleChange) => (
        <div className="criteria-form--seriesid-criteria">
            <label htmlFor={`seriesID${criteriaId}`}>Series ID</label>
            <InputText
                className="criteria-form--seriesid-text"
                id={`seriesID${criteriaId}`}
                value={seriesID}
                onChange={handleChange}
            />
        </div>
    );

    renderEchostarIDs = ({echostarIds} = {}, criteriaId, handleChange) => (
        <div className="criteria-form--echostarid-criteria">
            <label htmlFor={`echostarIDs${criteriaId}`}>Echostar IDs - Enter as a comma separated list</label>
            <InputTextarea
                autoResize={true}
                className="criteria-form--echostarid-textarea"
                id={`echostarIDs${criteriaId}`}
                value={echostarIds}
                onChange={handleChange}
            />
        </div>
    );

    renderRecommendationType({type, additionalData} = {}, criteriaId, handleChange) {
        const recommendationEngineOptions = TypeOfRecommendations.map(recommendationEngine => ({
            label: recommendationEngine.label,
            value: recommendationEngine.label,
        }));

        return (
            <div className="criteria-form--recommendation-criteria">
                <label htmlFor={`recommendationsEngine${criteriaId}`}>Recommendations Engine</label>
                <Dropdown
                    className="criteria-form--recommendations-engine"
                    filterPlaceholder="Select Recommendations Engine"
                    id={`recommendationsEngine${criteriaId}`}
                    options={recommendationEngineOptions}
                    showClear={false}
                    value={type}
                    onChange={handleChange}
                />
                <label htmlFor={`additionalData${criteriaId}`}>Additional Data</label>
                <InputText
                    className="criteria-form--additional-data"
                    id={`additionalData${criteriaId}`}
                    style={{width: '500px'}}
                    value={additionalData}
                    onChange={handleChange}
                />
            </div>
        );
    }

    renderReleaseDecade = ({decades} = {}, criteriaId, handleChange) => (
        <ReleaseDecadePicker
            criteriaId={criteriaId}
            existingReleaseDecades={decades}
            id={`releaseDecade${criteriaId}`}
            name={`releaseDecade${criteriaId}`}
            onChange={handleChange}
        />
    );

    renderAirDayOfWeek = ({dayOfWeek} = {}, criteriaId, handleChange) => (
        <div>
            <AirDayOfWeekList
                id={`airDayOfWeek${criteriaId}`}
                name={`airDayOfWeek${criteriaId}`}
                value={dayOfWeek}
                onChange={handleChange}
            />
        </div>
    );

    renderReleaseYear = ({releaseYear} = {}, criteriaId, handleChange) => (
        <div className="criteria-form--releaseyear-criteria">
            <Spinner
                id={`releaseYear${criteriaId}`}
                max={new Date().getFullYear()}
                min={1888}
                name={`releaseYear${criteriaId}`}
                value={Number(releaseYear)}
                onChange={handleChange}
            />
        </div>
    );

    renderAmount(criteriaObj, criteriaId, handleChange) {
        return (
            <div className="criteria-form--amount-criteria">
                <label htmlFor={`amountFrom${criteriaObj.amountFrom}`}>From</label>
                $
                <InputText
                    className="criteria-form--amount-text"
                    id={`amountFrom${criteriaId}`}
                    value={criteriaObj.amountFrom}
                    onChange={handleChange}
                />
                <label htmlFor={`amountFrom${criteriaObj.amountFrom}`}>To</label>
                $
                <InputText
                    className="criteria-form--amount-text"
                    id={`amountTo${criteriaId}`}
                    value={criteriaObj.amountTo}
                    onChange={handleChange}
                />
            </div>
        );
    }

    renderCriteriaDeleteFooter = () => (
        <div>
            <Button className="p-button-danger" icon="pi pi-check" label="DELETE" onClick={this.handleDeleteCriteria} />
            <Button icon="pi pi-times" label="No" onClick={this.onDeleteDialogHide} />
        </div>
    );

    renderCardHeader = (shelfObj, idx) => (
        <button className="criteria-form--button" onClick={() => this.onClickDeleteCriteria(shelfObj.criteria[idx])}>
            ×
        </button>
    );

    renderDeleteCriteriaDialog(idx) {
        const {deleteDialogVisible, criteriaObjToDelete} = this.state;

        return criteriaObjToDelete ? (
            <Dialog
                className="criteria-form--delete-criteria"
                footer={this.renderCriteriaDeleteFooter()}
                header="Delete Criteria ?"
                id={`${idx}`}
                modal={true}
                visible={deleteDialogVisible}
                onHide={this.onDeleteDialogHide}
            >
                CriteriaID: {criteriaObjToDelete.id}
                <br />
                Criteria Type: {criteriaObjToDelete.class}
            </Dialog>
        ) : null;
    }

    renderTitle({keyword, matchType} = {}, criteriaId, handleChange) {
        const matchTypeOptions = Object.keys(MatchTypes).map(matchType => ({
            label: MatchTypes[matchType].label,
            value: matchType,
        }));

        return (
            <div className="criteria-form--title-criteria">
                <label htmlFor={`titleName${criteriaId}`}>Title Name</label>
                <InputText
                    className="criteria-form--title-text"
                    id={`titleName${criteriaId}`}
                    value={keyword}
                    onChange={handleChange}
                />

                <br />
                <br />
                <label htmlFor={`matchType${criteriaId}`}>Match Type</label>
                <Dropdown
                    className="criteria-form--match-type"
                    filterPlaceholder="Select Match Type"
                    id={`matchType${criteriaId}`}
                    options={matchTypeOptions}
                    showClear={false}
                    value={matchType}
                    onChange={handleChange}
                />
            </div>
        );
    }

    render() {
        const {shelfObj} = this.props;

        return shelfObj.criteria.map((_val, idx) => (
            <div key={idx} style={{padding: '0.5em'}}>
                <Card
                    className="criteria-form--card"
                    header={this.renderCardHeader(shelfObj, idx)}
                    subTitle={CriterionList[shelfObj.criteria[idx].class].description}
                    title={`${idx + 1}. ${CriterionList[shelfObj.criteria[idx].class].criterionName}`}
                >
                    {this.renderShelfCriteria(shelfObj.criteria[idx], idx)}
                </Card>
                {this.renderDeleteCriteriaDialog(idx)}
            </div>
        ));
    }
}

CriteriaForm.propTypes = {
    deleteCriteria: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    handleUpdateAlias: PropTypes.func.isRequired,
    handleUpdateExtAttributes: PropTypes.func.isRequired,
    handleUpdateNetworkTags: PropTypes.func.isRequired,
    handleUpdateSubTheme: PropTypes.func.isRequired,
    shelfObj: PropTypes.object.isRequired,
    updateResolutionList: PropTypes.func.isRequired,
};

function mapStateToProps(state) {
    return {...state.updateShelf};
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({...addShelfActions, push}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(CriteriaForm);
